import { css } from 'styled-components';
import { ie11Mixin, mediaMixin, spaceMixin } from '@zillow/constellation';

/**
 * Hides a section in the layout if it is not expanded and it is not on the first
 * row. In IE11, we also set the flex-basis to slightly less than 1/2 and 1/3 on
 * tablet and desktop respectively, to account for padding and margins when using
 * flex-wrap in the container.
 */
const showSection = css`
  // will be used by browsers that don't understand unset (IE11)
  display: initial;
  display: unset;
`;
export default css`
  ${mediaMixin(
    'sm_lte',
    css`
      ${(props) =>
        props.isExpanded || props.index < 1
          ? showSection
          : css`
              display: none;
            `}
      ${ie11Mixin(css`
        flex: 0 0 100%;
      `)}
    `,
  )}
  ${mediaMixin(
    'md',
    css`
      ${(props) =>
        props.isExpanded || props.index < 2
          ? showSection
          : css`
              display: none;
            `}
      ${ie11Mixin(css`
        flex: 0 0 45%;
        padding: ${spaceMixin('xs')};
    }`)}
    `,
  )}
${mediaMixin(
    'lg',
    css`
      ${(props) =>
        props.isExpanded || props.index < 3
          ? showSection
          : css`
              display: none;
            `}
      ${ie11Mixin(css`
        flex: 0 0 30%;
        padding: ${spaceMixin('xs')};
    }`)}
    `,
  )}
${mediaMixin(
    'xl',
    css`
      ${(props) =>
        props.isExpanded || props.index < 4
          ? showSection
          : css`
              display: none;
            `}
      ${ie11Mixin(css`
        flex: 0 0 20%;
        padding: ${spaceMixin('xs')};
    }`)}
    `,
  )}
@media print {
    ${showSection}
  }
`;
